<form class="row" (ngSubmit)="verifyNumber()">
  <div class="col-sm-10 col-xs-9 pr0">
    <input [disabled]="verification_inprogress" type="text" class="form-control scroll-browser ml0 pl" placeholder="Enter mobile number of recipient to start chat" [(ngModel)]="input_token" required name="phone_number">
  </div>
  <div class="col-sm-2 col-xs-3">
    <button class="btn btn-secondary col-xs-12" type="submit" [disabled]="verification_inprogress">Verify</button>
  </div>
  <span class="text-red col-xs-12 fs11">{{error_message}}</span>
</form>
